import { createSvgIcon } from "@mui/material";

export const Icon = createSvgIcon(
  <>
    <path d="M20.18,10.31h-.79v-.37c0-1.67-1.08-3.12-2.64-3.6v-1.67c0-.35-.29-.64-.64-.64-1.34,0-2.53.86-2.95,2.11h-6.7c-2.09.02-3.8,1.74-3.8,3.8v1.12c-.4.29-.66.77-.66,1.25v.02c.02.53.26.97.68,1.23v.86c0,1.58.94,2.97,2.4,3.54v.97c0,.59.48,1.05,1.05,1.05h.97c.59,0,1.05-.48,1.05-1.05v-.7h4.84v.7c0,.59.48,1.05,1.05,1.05h.97c.59,0,1.05-.48,1.05-1.05v-.73c1.21-.18,2.26-.9,2.84-1.96h1.27c1.01,0,1.82-.79,1.82-1.82v-2.29c0-1.01-.81-1.82-1.82-1.82ZM11.85,7.69h-3.52c-.18,0-.33-.15-.33-.33s.15-.33.33-.33h3.52c.18,0,.33.15.33.33s-.15.33-.33.33ZM16.84,9.34c.24,0,.44.55.44,1.21s-.2,1.21-.44,1.21-.44-.55-.44-1.21.2-1.21.44-1.21ZM17.58,16.11c-.73,0-1.96-.29-1.96-1.32,0-.18.15-.33.33-.33s.33.15.33.33c0,.64,1.27.66,1.3.66.18,0,.33.15.33.33s-.15.33-.33.33Z" />
  </>,
  "Savings",
);

export default Icon;
